const _checkExpand = (el) => {
  if (el) {
  /* eslint-disable no-param-reassign */
    el.style.height = '';
    el.style.height = `${el.scrollHeight}px`;
  /* eslint-enable no-param-reassign */
  }
};

export default {
  bind (el) {
    el.addEventListener('keyup', _checkExpand.bind(this, el));
  },
  unbind (el) {
    el.removeEventListener('keyup', _checkExpand);
  },
  componentUpdated (el) {
    _checkExpand(el);
  },
};
